

import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { useEffect, useRef, useState } from 'react';

export type SvgTooltipProps = {
	tooltip: string;
	cx: number;
	cy: number;
	fontSize: number;
	padding: [number, number, number, number];
};

export const SvgTooltip = (props: SvgTooltipProps): React.ReactElement<SVGGElement> => {
	const { cx, cy, tooltip, fontSize, padding } = props;

	const [tooltipSize, setTooltipSize] = useState({ height: 0, width: 0 });
	const [prevTooltip, setPrevTooltip] = useState('');

	const refTooltipGroup = useRef<SVGGElement>(null);
	const refTooltipContainer = useRef<SVGRectElement>(null);
	const refTooltipText = useRef<SVGTextElement>(null);

	useEffect(() => {
		if (refTooltipText.current) {
			const bbox = refTooltipText.current.getBBox();
			setTooltipSize({ height: bbox.height, width: bbox.width });
		}

		if (tooltip !== '') setPrevTooltip(tooltip);
	}, [tooltip]);

	// tooltip position
	const xTooltip = cx;
	const yTooltip = cy + padding[0];

	const wTooltipRect = tooltipSize.width + padding[1] + padding[3];
	const hTooltipRect = tooltipSize.height + padding[0] + padding[2];
	const xTooltipRect = xTooltip - (wTooltipRect / 2);
	const yTooltipRect = yTooltip - (hTooltipRect / 2)

	// manage tooltip animations
	useGSAP(() => {
		gsap.to(refTooltipGroup.current, {
			opacity: tooltip === '' ? 0 : 1,
			duration: 0.5,
			ease: 'power1.out'
		});
	}, [tooltip, refTooltipText, refTooltipContainer]);

	return (
		<g ref={refTooltipGroup} opacity="0">
			<rect ref={refTooltipContainer}
				rx=".5" ry=".5"
				x={xTooltipRect} y={yTooltipRect}
				height={hTooltipRect}
				width={wTooltipRect}
				fill="white" stroke="black" strokeWidth=".125"
			/>

			<text ref={refTooltipText}
				x={xTooltip} y={yTooltip}
				fontSize={fontSize}
				textAnchor="middle" alignmentBaseline="middle"
				fill="black">
				{tooltip ? tooltip : prevTooltip}
			</text>
			{/* </>} */}
		</g>
	);
};
